import styled from "styled-components";
import { UIWidgetsDiv } from "../division/Division";

const UIWidgetsSideNavBar = styled(UIWidgetsDiv)`
  justify-content: flex-start;
  padding: 24px 0px;
  & > * {
    flex: 1;
  }
  & li {
    padding: 0px 24px;
  }
`;

export const UIWidgetsSideNavBarList = styled.ul`
  list-style-type: none;
  padding-inline-start: 0px;
  display: flex;
  flex-direction: column;
`;

export const UIWidgetsSideNavBarListItem = styled.li`
  flex-direction: row;
  align-items: center;
  display: flex;
  flex: 1;
  & > div:first-child {
    margin-left: 0px;
    margin-right: 12px;
  }
  background-color: ${props =>
    props.active ? props.theme.brandGrey : props.theme.brandWhite};
  & > div {
    background-color: ${props =>
      props.active ? props.theme.brandGrey : props.theme.brandWhite};
  }
`;

export const UIWidgetsSideNavFavAssets = styled(UIWidgetsDiv)``;

export default UIWidgetsSideNavBar;
